import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import Grid from "@material-ui/core/Grid/Grid";
import {connect} from "trim-redux";
import Typography from "@material-ui/core/Typography/Typography";
import IconButton from "@material-ui/core/IconButton/IconButton";
import MoneyOffRoundedIcon from '@material-ui/icons/MoneyOffRounded';
import {currencySymbol, price} from "../../../../config/values";
import Link from "@material-ui/core/Link/Link";
import FeaturedPlayListOutlinedIcon from '@material-ui/icons/FeaturedPlayListOutlined';
import StorefrontOutlinedIcon from '@material-ui/icons/StorefrontOutlined';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import MenuBookRoundedIcon from '@material-ui/icons/MenuBookRounded';
class SingleCartItem extends React.Component {

    state = {
        cart:this.props.cart,
    };
    classes = this.props.classes;

    render(){
        let {pricing,product} = this.state.cart;
        let {cart} = this.state;
        console.log(pricing);
        return (
            <div style={{border:"1px solid #eee",marginBottom:10,borderRadius:4}}>
            <Grid container alignItems="center">
                <Grid item xs={12} md={2} lg={2} className="text-center">
                    <Link href={`${defaultVariabls.website}/product/${product.slug}`} target="_blank">
                    <img
                        src={`${defaultVariabls.uploads}/FileManager/${product.thumbnail.name}_book.${product.thumbnail.extension}`}
                        alt="img"
                        className="single-order-items-img"
                    />
                    </Link>
                </Grid>
                <Grid item xs={6} md={5} lg={5} className="single_order_items">
                    <Typography style={{marginBottom:10}}>
                        <IconButton size="small"><FeaturedPlayListOutlinedIcon/></IconButton>{Translate.product}: <strong>{product.name} {!!pricing.value_id ? " ("+pricing.value.attribute.name+" "+(pricing.value.attribute.type === "color" ? pricing.value.description : pricing.value.name) +") " : ''}</strong></Typography>
                    <Typography  style={{marginBottom:10}}><IconButton size="small"><StorefrontOutlinedIcon/></IconButton>{Translate.shop}: <strong>{pricing.shop.name}</strong></Typography>
                    <Typography  style={{marginBottom:10}}><IconButton size="small"><MonetizationOnOutlinedIcon/></IconButton>{Translate.price}: <strong>{price(cart.final_price)+" "+currencySymbol}</strong> <span style={{color:this.props.primary_color,fontSize:11}}>({cart.quantity+" "+Translate.number})</span></Typography>

                </Grid>
                <Grid item xs={6} md={5} lg={5} className="single_order_items">
                    {
                        (!!pricing.need_verification || !!this.props.global_need_verification) &&
                    <Tooltip title={Translate.need_verification_description_user} arrow>
                        <Typography  style={{marginBottom:10}}>
                            <IconButton size="small"><InfoRoundedIcon/></IconButton>
                            <strong>{Translate.need_verification_hint}</strong>
                        </Typography>
                    </Tooltip>
                }
                    {
                        !!cart.is_whole &&
                        <Typography  style={{marginBottom:10}}><IconButton size="small"><LocalShippingOutlinedIcon/></IconButton>{Translate.wholesale}</Typography>
                    }
                    {
                        cart.product.situation === "worked" &&
                        <Typography  style={{marginBottom:10}}><IconButton size="small"><MenuBookRoundedIcon/></IconButton>{Translate.workedBook}</Typography>
                    }
                    {
                        cart.final_discount_price ?
                            <Typography  style={{marginBottom:10,color:"#f82e4e"}} color="primary"><IconButton size="small"><MoneyOffRoundedIcon color="primary" /></IconButton>{Translate.discount}: <strong>{price(cart.final_discount_price)+" "+currencySymbol}</strong></Typography>
                            : null
                    }
                </Grid>
            </Grid>
            </div>
        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color,
    global_need_verification: state.global_need_verification
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(SingleCartItem))));